import SEOHead from '@/components/base/SEOHead';
import HeroSection from './components/HeroSection';
import CategoryNav from './components/CategoryNav';
import FeaturedArticles from './components/FeaturedArticles';
import LatestUpdates from './components/LatestUpdates';
import MembershipSection from './components/MembershipSection';

export default function Home() {
  const schema = {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: '蜜桃传媒 - 官方平台入口与内容中心',
    description: '蜜桃传媒是专注优质内容创作与传播的媒体平台，汇聚海量精品资源，为用户提供极致娱乐体验。',
    url: 'https://mitaomedia.com',
    mainEntity: {
      '@type': 'Organization',
      name: '蜜桃传媒',
      url: 'https://mitaomedia.com',
      description: '蜜桃传媒是专注优质内容创作与传播的媒体平台。',
    },
  };

  return (
    <>
      <SEOHead
        title="官方平台入口与内容中心"
        description="蜜桃传媒是专注优质内容创作与传播的媒体平台，汇聚海量精品资源，为用户提供极致娱乐体验。探索蜜桃传媒官方频道，发现最新内容更新、独家资源与会员专属服务，立即访问蜜桃传媒官网，开启全新娱乐旅程。"
        canonicalUrl="https://mitaomedia.com"
        schemaJson={schema}
      />
      <main>
        <HeroSection />
        <CategoryNav />
        <FeaturedArticles />
        <LatestUpdates />
        <MembershipSection />
      </main>
    </>
  );
}